export const FREE_TRIAL_PAGE_TYPE = {
  WAITING: 'waiting',
  PICKUP: 'pickup',
  SURVEY: 'survey',
};
